import * as angular from 'angular';
import { Decimal } from 'decimal.js';
import { BigDecimal } from '../custom';

export interface MultiplyUnDiscountedIfFilter extends ng.IFilterFunction {}

function MultiplyUnDiscountedIfFilter(): MultiplyUnDiscountedIfFilter {
    // Since 01.01.2020 all undiscounted values are calculated with factor 4 - where used
    const defaultUndiscountedFactor = 4;

    return function (
        input: BigDecimal,
        undiscounted: boolean,
        discountedStorageFactor?: string,
        defaultUndiscountedMultiplicationCondition?: boolean
    ): BigDecimal {
        if (!input || !input.value) {
            return input;
        }

        let result: Decimal;

        if (angular.isString(input.value)) {
            result = new Decimal(input.value);
        } else {
            result = input.value;
        }

        /* Introduced with EM-1082, storage interconnection points will be uploaded with undiscounted RT (default for
           everything else still is RT = discounted. As we don't want to check for grid node type each time, we can be sure that
           the 'discounted factor' is only set for applicable points. So in case the discount is set (may be more point types
           some time) we use it to calculate the discounted price. For default behaviour we still consider the given value as
           undiscounted and calculate the discounted value by multiplying 4
         */

        if (
            discountedStorageFactor !== undefined &&
            discountedStorageFactor !== null &&
            undiscounted
        ) {
            return { value: result, floatingPointNumber: true };
        } else if (
            discountedStorageFactor !== undefined &&
            discountedStorageFactor !== null &&
            !undiscounted
        ) {
            return {
                value: result.times(discountedStorageFactor),
                floatingPointNumber: true
            };
        }

        if (!defaultUndiscountedMultiplicationCondition) {
            return input;
        }

        return {
            value: result.times(defaultUndiscountedFactor),
            floatingPointNumber: true
        };
    };
}

angular
    .module('app')
    .filter('pkpMultiplyUnDiscountedIf', MultiplyUnDiscountedIfFilter);
